<template>
	<textarea
		ref="input"
		class="input-text-area"
		:value="value ?? ''"
		@input="onInput"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
	></textarea>
</template>

<script setup lang="ts">
import { ref } from 'vue';

defineProps<{ value?: string | null | undefined }>();

const emit = defineEmits<{
	(e: 'input', value: string): void;
	(e: 'focus'): void;
	(e: 'blur'): void;
}>();

const input = ref<HTMLInputElement | null>(null);

function onInput(e: Event) {
	emit('input', (e.target as HTMLTextAreaElement).value);
}

defineExpose({ input });
</script>

<style scoped lang="scss">
.input-text-area {
	all: unset;
	display: flex;
	padding: 12px 16px;
	align-items: center;
	justify-self: stretch;
	gap: 12px;
	border-radius: 8px;
	background-color: var(--background-bg-medium, #111924);
	line-height: 16px;
	letter-spacing: 0.24px;
}
</style>
